// extracted by mini-css-extract-plugin
export default {"resourcesLimits":"ResourcesLimits_resourcesLimits__xwcB1","accessibleResources":"ResourcesLimits_accessibleResources__4xUH5","resourceItem":"ResourcesLimits_resourceItem__VtvWN"};